// auth
export const AUTHENTICATE_USER = "AUTHENTICATE_USER";
export const LOGIN_USER = "LOGIN_USER";
export const GET_LOGGED_IN_USER = "GET_LOGGED_IN_USER";
export const LOGOUT_USER = "LOGOUT_USER";
